import { defineMessages } from 'react-intl';

export default defineMessages({
  doorsAbrev: {
    id: 'global_doors_abrev',
    defaultMessage: 'Doors',
    description: 'cars',
  },
  mileageAbrev: {
    id: 'global_mileage_abrev',
    defaultMessage: 'Mi.',
    description: 'cars',
  },
  yearAbrev: {
    id: 'global_year',
    defaultMessage: 'Year',
    description: 'cars',
  },
});



// WEBPACK FOOTER //
// ./app/components/mobile/Features/cars/messages.js